import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { getAuthToken } from "@/utils/util";

const PermissionRoute = (props) => {
  const location = useLocation();
  const { permissioned } = useSelector((state) => state.auth, shallowEqual);
  console.log("permissioned", permissioned);
  const isAuthenticated = permissioned || getAuthToken().isLogin;

  const isLoginPath = location.pathname === "/login";
  if (!isAuthenticated && !isLoginPath) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return props.children;
};

PermissionRoute.propTypes = {
  route: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired
};

export default PermissionRoute;
